module.exports = __webpack_public_path__ + "media/images/bitcoin-lightning-795a69f3f5ff61c10204629d0f523b40.svg";